import type { InstallWhatsappIntegrationInput, UpdateWhatsappIntegrationInput, WhatsappIntegration, WhatsappProviderSummary } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

const json = (body: unknown) => JSON.stringify(body);

export function listWhatsappProviders(): Promise<WhatsappProviderSummary[]> {
  return api<WhatsappProviderSummary[]>('/whatsapp/providers');
}

/** At most one installation per shipped provider, so the API returns them all, unpaged. */
export function listWhatsappIntegrations(): Promise<WhatsappIntegration[]> {
  return api<WhatsappIntegration[]>('/whatsapp/integrations');
}

export function getWhatsappIntegration(id: string): Promise<WhatsappIntegration> {
  return api<WhatsappIntegration>(`/whatsapp/integrations/${id}`);
}

export function installWhatsappIntegration(input: InstallWhatsappIntegrationInput): Promise<WhatsappIntegration> {
  return api<WhatsappIntegration>('/whatsapp/integrations', { method: 'POST', body: json(input) });
}

export function updateWhatsappIntegration(id: string, input: UpdateWhatsappIntegrationInput): Promise<WhatsappIntegration> {
  return api<WhatsappIntegration>(`/whatsapp/integrations/${id}`, { method: 'PATCH', body: json(input) });
}

export function checkWhatsappIntegration(id: string): Promise<WhatsappIntegration> {
  return api<WhatsappIntegration>(`/whatsapp/integrations/${id}/check`, { method: 'POST' });
}

export function startWhatsappSending(id: string): Promise<WhatsappIntegration> {
  return api<WhatsappIntegration>(`/whatsapp/integrations/${id}/start-sending`, { method: 'POST' });
}

export function stopWhatsappSending(id: string): Promise<WhatsappIntegration> {
  return api<WhatsappIntegration>(`/whatsapp/integrations/${id}/stop-sending`, { method: 'POST' });
}

export function uninstallWhatsappIntegration(id: string): Promise<void> {
  return api<void>(`/whatsapp/integrations/${id}`, { method: 'DELETE' });
}
